/**
 * Quick View — Dawn Theme
 * Funcionalidad completa: modal, galería, variantes, carrito, wishlist
 */

(function () {
  'use strict';

  /* ============================================================
     CONFIG
     ============================================================ */
  const QV_CONFIG = {
    cartApiUrl: '/cart/add.js',
    productApiUrl: (handle) => `/products/${handle}.js`,
    checkoutUrl: '/checkout',
    descMaxChars: 120,
  };

  /* ============================================================
     ESTADO
     ============================================================ */
  const state = {
    currentProduct: null,
    currentVariant: null,
    currentImageIndex: 0,
    totalImages: 0,
    isLoading: false,
    wishlist: JSON.parse(localStorage.getItem('qv_wishlist') || '[]'),
  };

  /* ============================================================
     ELEMENTOS DOM
     ============================================================ */
  let modal, overlay, track, dotsContainer, prevBtn, nextBtn;
  let titleEl, subtitleEl, priceEl, compareEl, discountBadgeEl;
  let descEl, variantsEl, qtyInput, wishlistBtn;
  let buyNowBtn, addCartBtn, fullLink, badgeEl;

  /* ============================================================
     INICIALIZACIÓN
     ============================================================ */
  function init() {
    injectModal();
    cacheElements();
    bindEvents();
    injectTriggers();
    createToast();
  }

  function injectModal() {
    if (!document.getElementById('quick-view-modal')) {
      console.warn('[QuickView] El snippet quick-view.liquid no está incluido en el layout.');
    }
  }

  function cacheElements() {
    modal           = document.getElementById('quick-view-modal');
    overlay         = modal;
    track           = document.getElementById('qv-track');
    dotsContainer   = document.getElementById('qv-dots');
    prevBtn         = document.getElementById('qv-prev');
    nextBtn         = document.getElementById('qv-next');
    titleEl         = document.getElementById('qv-title');
    subtitleEl      = document.getElementById('qv-subtitle');
    priceEl         = document.getElementById('qv-price');
    compareEl       = document.getElementById('qv-compare');
    discountBadgeEl = document.getElementById('qv-discount-badge');
    descEl          = document.getElementById('qv-desc');
    variantsEl      = document.getElementById('qv-variants');
    qtyInput        = document.getElementById('qv-qty-input');
    wishlistBtn     = document.getElementById('qv-wishlist');
    buyNowBtn       = document.getElementById('qv-buy-now');
    addCartBtn      = document.getElementById('qv-add-cart');
    fullLink        = document.getElementById('qv-full-link');
    badgeEl         = document.getElementById('qv-badge');
  }

  /* ============================================================
     INYECTAR TRIGGERS en las cards del tema
     ============================================================ */
  function injectTriggers() {
    const cards = document.querySelectorAll(
      '.card-wrapper, .product-card-wrapper, [data-product-handle]'
    );

    cards.forEach((card) => {
      const handle = getHandleFromCard(card);
      if (!handle) return;

      if (card.querySelector('.qv-trigger')) return;

      const imgWrapper = card.querySelector(
        '.card__media, .card-media, .product-card__image, figure, [class*="media"]'
      ) || card;

      imgWrapper.style.position = 'relative';

      const btn = document.createElement('button');
      btn.className = 'qv-trigger';
      btn.setAttribute('aria-label', 'Vista rápida del producto');
      btn.dataset.handle = handle;
      btn.type = 'button';

      btn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0817/2807/8043/files/icon-add-cart.svg?v=1777781949" width="36" height="36" alt="" aria-hidden="true" style="display:block;">`;

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openModal(handle);
      });

      imgWrapper.appendChild(btn);
    });
  }

  function getHandleFromCard(card) {
    if (card.dataset.productHandle) return card.dataset.productHandle;
    if (card.dataset.handle) return card.dataset.handle;

    const link = card.querySelector('a[href*="/products/"]');
    if (link) {
      const match = link.href.match(/\/products\/([^?#/]+)/);
      if (match) return match[1];
    }

    return null;
  }

  /* ============================================================
     ABRIR / CERRAR MODAL
     ============================================================ */
  async function openModal(handle) {
    if (state.isLoading) return;
    showModal();
    showSkeleton();

    try {
      const product = await fetchProduct(handle);
      state.currentProduct = product;
      state.currentVariant = product.variants[0];
      state.currentImageIndex = 0;
      state.totalImages = product.images.length;
      renderModal(product);
    } catch (err) {
      console.error('[QuickView] Error cargando producto:', err);
      showError();
    }
  }

  function showModal() {
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      overlay.style.opacity = '1';
    });
    setTimeout(() => {
      const closeBtn = modal.querySelector('.qv-close');
      if (closeBtn) closeBtn.focus();
    }, 300);
  }

  function closeModal() {
    overlay.style.opacity = '0';
    document.body.style.overflow = '';
    setTimeout(() => {
      overlay.hidden = true;
      clearModal();
    }, 250);
  }

  function clearModal() {
    track.innerHTML = '';
    dotsContainer.innerHTML = '';
    variantsEl.innerHTML = '';
    titleEl.textContent = '';
    descEl.innerHTML = '';
  }

  /* ============================================================
     FETCH PRODUCTO
     ============================================================ */
  async function fetchProduct(handle) {
    const res = await fetch(QV_CONFIG.productApiUrl(handle));
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  }

  /* ============================================================
     RENDER MODAL
     ============================================================ */
  function renderModal(product) {
    titleEl.textContent = product.title;
    subtitleEl.textContent = product.variants[0]?.weight
      ? `${product.variants[0].weight} ${product.variants[0].weight_unit}`
      : '';

    if (product.type) {
      badgeEl.textContent = product.type;
      badgeEl.hidden = false;
    } else {
      badgeEl.hidden = true;
    }

    renderGallery(product.images);
    renderPrice(product.variants[0]);
    renderDescription(product.description);
    renderVariants(product);
    updateWishlistBtn(product.id);
    fullLink.href = `/products/${product.handle}`;
  }

  /* ---------- Galería ---------- */
  function renderGallery(images) {
    track.innerHTML = '';
    dotsContainer.innerHTML = '';

    if (!images || images.length === 0) {
      track.innerHTML = '<div class="qv-gallery__slide"><div style="width:200px;height:200px;background:#f0f0ec;border-radius:12px;"></div></div>';
      return;
    }

    images.forEach((img, i) => {
      const rawSrc = typeof img === 'string' ? img : (img.src || img);

      const slide = document.createElement('div');
      slide.className = 'qv-gallery__slide';
      const image = document.createElement('img');
      image.src = getSizedImage(rawSrc, '600x');
      image.alt = typeof img === 'object' && img.alt ? img.alt : '';
      image.loading = i === 0 ? 'eager' : 'lazy';
      slide.appendChild(image);
      track.appendChild(slide);

      if (images.length > 1) {
        const dot = document.createElement('button');
        dot.className = 'qv-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Imagen ${i + 1}`);
        dot.dataset.index = i;
        dot.addEventListener('click', () => goToSlide(i));
        dotsContainer.appendChild(dot);
      }
    });

    state.totalImages = images.length;
    updateNavVisibility();
    goToSlide(0);
  }

  function goToSlide(index) {
    state.currentImageIndex = index;
    track.style.transform = `translateX(-${index * 100}%)`;

    document.querySelectorAll('.qv-dot').forEach((d, i) => {
      d.classList.toggle('is-active', i === index);
    });

    updateNavVisibility();
  }

  function updateNavVisibility() {
    const total = state.totalImages;
    prevBtn.hidden = total <= 1 || state.currentImageIndex === 0;
    nextBtn.hidden = total <= 1 || state.currentImageIndex >= total - 1;
  }

  /* ---------- Precio ---------- */
  function renderPrice(variant) {
    if (!variant) return;

    const price = formatMoney(variant.price);
    const comparePrice = variant.compare_at_price;

    priceEl.textContent = price;

    if (comparePrice && comparePrice > variant.price) {
      compareEl.textContent = formatMoney(comparePrice);
      compareEl.hidden = false;

      const pct = Math.round((1 - variant.price / comparePrice) * 100);
      discountBadgeEl.textContent = `${pct}% de descuento`;
      discountBadgeEl.hidden = false;
    } else {
      compareEl.hidden = true;
      discountBadgeEl.hidden = true;
    }
  }

  /* ---------- Descripción ---------- */
  function renderDescription(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    const text = tmp.textContent || '';
    const trimmed = text.length > QV_CONFIG.descMaxChars
      ? text.slice(0, QV_CONFIG.descMaxChars).trim() + '...'
      : text;

    descEl.innerHTML = trimmed
      ? `${trimmed} <a href="${fullLink.href}">Leer descripción</a>`
      : '';
  }

  /* ---------- Variantes ---------- */
  function renderVariants(product) {
    variantsEl.innerHTML = '';
    if (!product.options || product.options.length === 0) return;

    const relevantOptions = product.options.filter(
      (opt) => !(opt.values.length === 1 && opt.values[0] === 'Default Title')
    );
    if (relevantOptions.length === 0) return;

    relevantOptions.forEach((option) => {
      const group = document.createElement('div');
      group.className = 'qv-variants';

      const label = document.createElement('p');
      label.className = 'qv-variants__label';
      label.textContent = option.name;

      const optionsRow = document.createElement('div');
      optionsRow.className = 'qv-variants__options';

      option.values.forEach((value) => {
        const btn = document.createElement('button');
        btn.className = 'qv-variant-btn';
        btn.textContent = value;
        btn.type = 'button';

        if (option.position === 1 && state.currentVariant?.option1 === value) {
          btn.classList.add('is-selected');
        }

        btn.addEventListener('click', () => selectVariantByOption(option.position, value, product));
        optionsRow.appendChild(btn);
      });

      group.appendChild(label);
      group.appendChild(optionsRow);
      variantsEl.appendChild(group);
    });
  }

  function selectVariantByOption(position, value, product) {
    const selected = { ...getSelectedOptions() };
    selected[`option${position}`] = value;

    const variant = product.variants.find((v) =>
      Object.entries(selected).every(([key, val]) => v[key] === val)
    );

    if (variant) {
      state.currentVariant = variant;
      renderPrice(variant);

      if (variant.featured_image) {
        const imgIndex = product.images.findIndex(
          (img) => img.id === variant.featured_image.id
        );
        if (imgIndex !== -1) goToSlide(imgIndex);
      }
    }

    document.querySelectorAll(`[data-option-position="${position}"] .qv-variant-btn`).forEach((b) => {
      b.classList.toggle('is-selected', b.textContent === value);
    });
  }

  function getSelectedOptions() {
    const v = state.currentVariant;
    if (!v) return {};
    return { option1: v.option1, option2: v.option2, option3: v.option3 };
  }

  /* ============================================================
     CARRITO
     ============================================================ */
  async function addToCart(buyNow = false) {
    if (!state.currentVariant) {
      showToast('Selecciona una variante primero');
      return;
    }

    const variantId = state.currentVariant.id;
    if (!variantId) {
      showToast('Error: variante no válida');
      return;
    }

    const qty = parseInt(qtyInput.value, 10) || 1;
    const btn = buyNow ? buyNowBtn : addCartBtn;

    btn.classList.add('is-loading');
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = buyNow ? 'Procesando...' : 'Agregando...';

    try {
      const cartDrawer = document.querySelector('cart-drawer');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: qty,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.description || data.message || 'No se pudo agregar al carrito');
      }

      if (buyNow) {
        window.location.href = '/checkout';
        return;
      }

      closeModal();
      showToast('✓ Producto agregado al carrito');

      // Esperar que el modal cierre completamente
      await new Promise(resolve => setTimeout(resolve, 400));

      if (cartDrawer && data.sections) {
        await dawnRenderAndOpen(cartDrawer, data);
      } else {
        await triggerDawnCartFallback();
        await refreshCartCount();
      }

    } catch (err) {
      console.error('[QuickView] Error al agregar al carrito:', err);
      showToast(err.message || 'Error al agregar. Intenta de nuevo.');
    } finally {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.textContent = originalText;
    }
  }

  async function dawnRenderAndOpen(cartDrawer, data) {
    try {
      const cartDrawerSection = data.sections['cart-drawer'];
      const cartIconSection   = data.sections['cart-icon-bubble'];

      // 1. Actualizar #CartDrawer — el HTML viene dentro de .shopify-section > cart-drawer > #CartDrawer
      if (cartDrawerSection) {
        const parsed = new DOMParser().parseFromString(cartDrawerSection, 'text/html');
        const newCartDrawer = parsed.getElementById('CartDrawer');
        const currentCartDrawer = document.getElementById('CartDrawer');

        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
        }
      }

      // 2. Actualizar badge del ícono
      if (cartIconSection) {
        const parsed = new DOMParser().parseFromString(cartIconSection, 'text/html');
        const shopifySection = parsed.querySelector('.shopify-section');
        const curIcon = document.getElementById('cart-icon-bubble');

        if (shopifySection && curIcon) {
          // El bubble del contador viene dentro del shopify-section
          const newBubble = shopifySection.querySelector('.cart-count-bubble');
          const curBubble = curIcon.querySelector('.cart-count-bubble');

          if (newBubble && curBubble) {
            // Ya existe el bubble, solo actualizar el número
            curBubble.innerHTML = newBubble.innerHTML;
            curBubble.classList.remove('hidden');
          } else if (newBubble && !curBubble) {
            // Primera vez — no existe el bubble, agregarlo al <a>
            curIcon.appendChild(newBubble.cloneNode(true));
          }
        }
      }

      // 3. Quitar is-empty del drawer__inner y del cart-drawer
      cartDrawer.classList.remove('is-empty');
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner) drawerInner.classList.remove('is-empty');

      // 4. Re-vincular overlay
      const overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay) {
        const newOverlay = overlay.cloneNode(true);
        overlay.parentNode.replaceChild(newOverlay, overlay);
        newOverlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
      }

      // 5. Abrir drawer
      setTimeout(() => {
        cartDrawer.classList.add('animate', 'active');
      });

      // 6. trapFocus después de la transición
      cartDrawer.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = cartDrawer.classList.contains('is-empty')
          ? cartDrawer.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = cartDrawer.querySelector('.drawer__inner')
          || cartDrawer.querySelector('.drawer__close');
        if (containerToTrapFocusOn && typeof trapFocus === 'function') {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      }, { once: true });

      document.body.classList.add('overflow-hidden');

    } catch(e) {
      console.warn('[QuickView] dawnRenderAndOpen falló:', e);
      await triggerDawnCartFallback();
      await refreshCartCount();
    }
  }

  // Solo se usa si renderContents no está disponible
  async function triggerDawnCartFallback() {
    const root = window.Shopify?.routes?.root || '/';

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      try {
        const html = await fetch(`${root}?section_id=cart-drawer`).then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const currentItems = cartDrawer.querySelector('cart-drawer-items');
        const newItems = doc.querySelector('cart-drawer-items');
        if (currentItems && newItems) {
          currentItems.innerHTML = newItems.innerHTML;
        }
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
        return;
      } catch (e) {
        console.warn('[QuickView] Fallback cart-drawer falló', e);
      }
    }

    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      try {
        const html = await fetch(`${root}?section_id=cart-notification`).then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('cart-notification');
        if (fresh) cartNotification.innerHTML = fresh.innerHTML;
        if (typeof cartNotification.open === 'function') cartNotification.open();
        return;
      } catch (e) {
        console.warn('[QuickView] Fallback cart-notification falló', e);
      }
    }

    // Último recurso
    const cartIcon = document.querySelector('#cart-icon-bubble, .header__cart a, [href="/cart"]');
    if (cartIcon) cartIcon.click();
  }

  async function refreshCartCount() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const count = cart.item_count;
      document.querySelectorAll(
        '.cart-count-bubble span[aria-hidden], .cart-count-bubble span:not(.visually-hidden)'
      ).forEach(el => {
        el.textContent = count;
        el.closest('.cart-count-bubble')?.classList.remove('hidden');
      });
    } catch (e) {
      console.warn('[QuickView] No se pudo actualizar el badge', e);
    }
  }

  /* ============================================================
     WISHLIST (localStorage)
     ============================================================ */
  function toggleWishlist() {
    if (!state.currentProduct) return;
    const id = state.currentProduct.id;
    const idx = state.wishlist.indexOf(id);

    if (idx === -1) {
      state.wishlist.push(id);
      showToast('♡ Guardado en favoritos');
    } else {
      state.wishlist.splice(idx, 1);
      showToast('Eliminado de favoritos');
    }

    localStorage.setItem('qv_wishlist', JSON.stringify(state.wishlist));
    updateWishlistBtn(id);
  }

  function updateWishlistBtn(productId) {
    const isActive = state.wishlist.includes(productId);
    wishlistBtn.classList.toggle('is-active', isActive);
    wishlistBtn.setAttribute('aria-pressed', isActive);
  }

  /* ============================================================
     UTILS
     ============================================================ */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return `$${amount.replace(/\.00$/, '')}`;
  }

  function getSizedImage(src, size) {
    if (!src) return '';
    const [base, query] = src.split('?');
    const clean = base.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*|x\d+)(?=\.[^.]+$)/, '');
    const sized = clean.replace(/(\.[^.]+)$/, `_${size}$1`);
    return query ? `${sized}?${query}` : sized;
  }

  function showSkeleton() {
    titleEl.innerHTML = '<div class="qv-skeleton" style="height:28px;width:70%;"></div>';
    priceEl.innerHTML = '<div class="qv-skeleton" style="height:24px;width:80px;display:inline-block;"></div>';
    descEl.innerHTML = '<div class="qv-skeleton" style="height:14px;width:100%;margin-bottom:6px;"></div><div class="qv-skeleton" style="height:14px;width:85%;"></div>';
    track.innerHTML = '<div class="qv-gallery__slide"><div class="qv-skeleton" style="width:220px;height:220px;border-radius:12px;"></div></div>';
  }

  function showError() {
    titleEl.textContent = 'No se pudo cargar el producto';
    descEl.textContent = 'Por favor intenta de nuevo o visita la página del producto.';
  }

  /* ============================================================
     TOAST
     ============================================================ */
  let toastEl;

  function createToast() {
    toastEl = document.createElement('div');
    toastEl.className = 'qv-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastEl);
  }

  let toastTimeout;
  function showToast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimeout);
    toastTimeout = setTimeout(() => {
      toastEl.classList.remove('is-visible');
    }, 2800);
  }

  /* ============================================================
     EVENTOS
     ============================================================ */
  function bindEvents() {
    document.querySelectorAll('[data-qv-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hidden) closeModal();
    });

    prevBtn.addEventListener('click', () => {
      if (state.currentImageIndex > 0) goToSlide(state.currentImageIndex - 1);
    });

    nextBtn.addEventListener('click', () => {
      if (state.currentImageIndex < state.totalImages - 1) goToSlide(state.currentImageIndex + 1);
    });

    let touchStartX = 0;
    track.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        if (diff > 0 && state.currentImageIndex < state.totalImages - 1) goToSlide(state.currentImageIndex + 1);
        else if (diff < 0 && state.currentImageIndex > 0) goToSlide(state.currentImageIndex - 1);
      }
    }, { passive: true });

    document.getElementById('qv-qty-minus').addEventListener('click', () => {
      const val = parseInt(qtyInput.value, 10);
      if (val > 1) qtyInput.value = val - 1;
    });

    document.getElementById('qv-qty-plus').addEventListener('click', () => {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });

    wishlistBtn.addEventListener('click', toggleWishlist);
    buyNowBtn.addEventListener('click', () => addToCart(true));
    addCartBtn.addEventListener('click', () => addToCart(false));

    document.addEventListener('shopify:section:load', injectTriggers);
    document.addEventListener('collection:products:updated', injectTriggers);
  }

  /* ============================================================
     API PÚBLICA
     ============================================================ */
  window.QuickView = { open: openModal };

  /* ============================================================
     ARRANQUE
     ============================================================ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();